module.exports = __webpack_public_path__ + "img/wsocks.2764ae66.jpg";